var map = {
	"./preview-dark.png": "7ffd",
	"./preview-hybrid.png": "c4eb",
	"./preview-light.png": "5960",
	"./preview-roadmap.png": "7f5f",
	"./preview-satellite.png": "481d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d12";